












































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
// import {popupResize} from '@/utils/ncp';

import {GetInquiryTypeRequest, GetInquiryTypesInquiryTypeNoRequest, PutInquiriesRequest, Assignees, InquiryType, Failures} from 'supporter';

@Component({
  components: {PageTitle, CompSelectBox}
})
export default class TypeAndAdmin extends Vue {
  // query
  private localInquiryTypeNo: any = undefined;
  private localAssigneeNo: any = undefined;

  private putInquiriesRequest: PutInquiriesRequest = {
    data: {
      inquiryNos: [],
      assigneeNo: 0,
      mallNo: 0,
      inquiryTypeNo: 0,
      reason: ''
    }
  };

  private inquiryTypes: InquiryType[] = [];
  private assignees: Assignees[] = [];
  private channel: string = '';

  get getInquiryTypeRequest(): GetInquiryTypeRequest {
    return {
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
  }

  get isNaverPay(): boolean {
    return this.channel === 'NAVER_PAY';
  }

  private async getInquiryTypes() {
    await this.$api.getInquiryType(this.getInquiryTypeRequest).then(ret => {
      this.inquiryTypes = ret.data;
      this.inquiryTypes = this.inquiryTypes.filter((item: any): any => {
        return item.channel !== 'NAVER_PAY';
      })
    });
  }

  get getInquiryTypesInquiryTypeNoRequest(): GetInquiryTypesInquiryTypeNoRequest {
    return {
      pathParams: {
        inquiryTypeNo: this.localInquiryTypeNo
      },
      params: {
        mallNo: Number(this.$route.query.mallNo)
      }
    };
  }

  private async changeInquiryType() {
    let getInquiryTypesInquiryTypeNoRequest = {
          pathParams: {
            inquiryTypeNo: this.localInquiryTypeNo
          },
          params: {
            mallNo: Number(this.$route.query.mallNo)
          }
        }
    await this.$api.getInquiryTypesInquiryTypeNo(getInquiryTypesInquiryTypeNoRequest).then(ret => {
      let selectedInquiry = ret.data;
      if (selectedInquiry) {
        this.assignees = selectedInquiry.assignees;
      }
    });
  }

  private checkForm() {
    if (this.localInquiryTypeNo === undefined) {
      alert(this.$t('INQUIRY_TYPE_ADMIN_ERROR_INQUIRYTYPENO'));
      return false;
    }
    if (this.localAssigneeNo === undefined) {
      alert(this.$t('INQUIRY_TYPE_ADMIN_ERROR_ADMINNO'));
      return false;
    }
    if (this.putInquiriesRequest.data.reason === '') {
      alert(this.$t('INQUIRY_TYPE_ADMIN_ERROR_COMMENT'));
      return false;
    }
    return true;
  }

  private async apply() {
    if (!this.checkForm()) {
      return;
    }

    if (!confirm(this.$t('INQUIRY_TYPE_ADMIN_CONFIRM_COMMIT').toString())) {
      return;
    }

    this.putInquiriesRequest.data.inquiryTypeNo = Number(this.localInquiryTypeNo);
    this.putInquiriesRequest.data.assigneeNo = Number(this.localAssigneeNo);

    this.$api.putInquiries(this.putInquiriesRequest).then(ret => {

      let putInquiriesResponse = ret.data;
      let successMessage = putInquiriesResponse.successCount > 0 ? this.$t('INQUIRY_TYPE_ADMIN_PUT_INQUIRIES_SUCCESS').toString() + putInquiriesResponse.successCount + this.$t('INQUIRY_TYPE_ADMIN_PUT_INQUIRIES_CNT').toString() + ': ' + this.$t('INQUIRY_TYPE_ADMIN_PUT_INQUIRIES_SUCCESS_MESSAGE').toString() + '\r' : '';

      if(putInquiriesResponse.failCount > 0) {
        let failures = putInquiriesResponse.failures;
        let failMessageReason = '';

        if (failures) {
          failures.forEach((reasonAndTargetNo: Failures) => {
            if(reasonAndTargetNo) {
              failMessageReason = failMessageReason + reasonAndTargetNo.reason + this.getFailReason(reasonAndTargetNo.targetNos);
            }
          });
        }

        let failMessage = this.$t('INQUIRY_TYPE_ADMIN_PUT_INQUIRIES_FAIL').toString() + putInquiriesResponse.failCount + this.$t('INQUIRY_TYPE_ADMIN_PUT_INQUIRIES_CNT').toString() + ':' + failMessageReason;
        alert(successMessage + failMessage)
      } else {
        alert(successMessage);
      }

      this.gradeApply();
    });
  }

  private getFailReason(targetNos: number[]) : any {
    let targetNosStr = '';

    if(targetNos) {
      targetNosStr = targetNos.join(',');

      if (targetNosStr.length > 0) {
        targetNosStr = '(' + targetNosStr + ')';
      }
    }

     return targetNosStr;
  }

  private async gradeApply() {
    if (this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
    }
    window.close();
  }

  private cancel() {
    window.close();
  }

  private created() {}

  private async mounted() {
    if (this.$route.query.mallNo) {
      // 지급 대상회원

      this.putInquiriesRequest.data.mallNo = Number(this.$route.query.mallNo);
      // this.localInquiryTypeNo = Number(this.$route.query.inquiryTypeNo);
      if (this.$route.query.channel) {
        this.channel = this.$route.query.channel.toString();
      }
      this.putInquiriesRequest.data.inquiryNos = (this.$route.query.inquiryNos as string).split(',').map((item: string) => Number(item));
      await this.getInquiryTypes();
      let findInquiryType: InquiryType = this.inquiryTypes.find((inquiryType: InquiryType): {} => {
        return inquiryType.no === this.localInquiryTypeNo;
      })

      
      if (findInquiryType) {
        this.localInquiryTypeNo = this.$route.query.inquiryTypeNo === 'undefined' ? undefined : this.$route.query.inquiryTypeNo;
        await this.changeInquiryType();
      }
      // this.localInquiryTypeNo = this.$route.query.inquiryTypeNo === 'undefined' ? undefined : this.$route.query.inquiryTypeNo;
      // await this.changeInquiryType();
    }
  }
}
